import React, { useState, useEffect, useContext } from 'react'
import axios from 'axios'
import { API_URL } from '../../Constant';
import { ToastContainer, toast } from 'react-toastify';
import messages from '../../assets/Messages.json'
import { useNavigate } from 'react-router-dom';
import {showAppLoading,  generateYearRange, isNumeric, validateButtonASIBlock, getStatusFlagValue } from '../../Custom/Custom';
import asiTitle from '../../asi.json';
import BlockHJsonData from '../../assets/BlockHData.json';
import BlockIData from '../../assets/BlockIData.json';
import BlockJData from '../../assets/BlockJData.json';
import { BlockEContextData } from '../../context/BlockEContext';

export default function BlockE({
   blockPageInfo,
   config,
   userInfoObject,
   blockInfo,
   accessAsiBlock,
   decode_token,
   setBlockE19WagesOrSalaries,
   previewMode = false
}) {
const{setInitialData,initialData}=useContext(BlockEContextData)
   const [itemData, setItemData] = useState({});
   const [blockEData, setBlockEData] = useState({});
   const navigate = useNavigate();
   const yearRange = generateYearRange(blockInfo.surveyYear);
   const [buttonStatus, setButtonStatus] = useState('');
   const statusUnitCode = localStorage.getItem('statusUnitCode')
   const roleCodes = decode_token?.id?.ROLE_CODE
      ? String(decode_token.id.ROLE_CODE)
           .split('|')
           .map((r) => String(r).trim())
           .filter(Boolean)
      : [];
   const isDivasiRole = roleCodes.includes('DIVASI');
   const isHqRole = roleCodes.includes('HQADM') || roleCodes.includes('HQASI');
   const currentStatusFlag = Array.isArray(blockEData) && blockEData.length > 0 ? blockEData[0]?.statusFlag : '';
   const isDivasiStatusFlagOne = isDivasiRole && String(currentStatusFlag ?? '').trim() === '1';
   const isHqStatusFlagThree = isHqRole && String(currentStatusFlag ?? '').trim() === '3';
  const isRestrictedRoleWithEmptyStatusFlag = (isDivasiRole || isHqRole) && String(currentStatusFlag ?? '').trim() === '';
   const nextBlockId = statusUnitCode === '2' ? 12 : 6;
   const nextBlockRoute = statusUnitCode === '2' ? "/BlockL" : "/BlockF";
   const isNextBlockAlreadyAccessible = (() => {
      const ids = JSON.parse(localStorage.getItem('blockIds') || '[]');
      return Array.isArray(ids) && ids.map(Number).includes(nextBlockId);
   })();
   const [verifyBlockEWorkerEmpRatioE, setVerifyBlockEWorkerEmpRatioE] = useState({
      "fourDigNICCode": 0,
      "districtCode": 0,
      "minWorker": 0,
      "maxWorker": 0,
      "minEmp": 0,
      "maxEmp": 0,
      "noCheckWorker": 0,
      "noCheckEmp": 0
   });
   let srNo = 0;

   useEffect(() => {
      blockEAllData();
   }, [])
// console.log("initial data blocke",initialData)
   // Function to handle page load Form data
   const blockEAllData = async () => {
      const newObject = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      };

      //console.log(`${API_URL}api/asi/blockEForm`);
      showAppLoading(true)
      try {
         const response = await axios.post(`${API_URL}api/asi/blockEForm`, newObject, config);
         const { data, status } = response.data;
         if (status) {
            let responseBlockEData = data.blockEData;
            let wagesOrSalaries = '';

            // Find Item 14 (Total cost of Production) - catagoryId changes by year
            // Priority order: 114 -> 113 -> 56
            // Try to find Item 14 with priority order
            let item14Data = null;
            let item14CategoryId = null;
            
            if (Array.isArray(responseBlockEData)) {
               // Try catagoryId 114 first
               item14Data = responseBlockEData.find(item => item.catagoryId === 114);
               if (item14Data) {
                  item14CategoryId = 114;
               } else {
                  // Try catagoryId 113 (for 2023)
                  item14Data = responseBlockEData.find(item => item.catagoryId === 113);
                  if (item14Data) {
                     item14CategoryId = 113;
                  } else {
                     // Try catagoryId 56 (for 2022)
                     item14Data = responseBlockEData.find(item => item.catagoryId === 56);
                     if (item14Data) {
                        item14CategoryId = 56;
                     }
                  }
               }
            }
            
      
            if (item14Data) {
               console.log('Total cost of Production (in Rs.) [wagesOrSalaries]:', item14Data.wagesOrSalaries);
               // console.log('Category of Staff:', item14Data.categoryOfStaff);
               // console.log('Full Item 14 Object:', item14Data);
            } else {
               console.warn('⚠️ Item 14 (Total cost of Production) not found!');
               console.log('Available catagoryIds:', responseBlockEData.map(item => item.catagoryId));
            }
            // console.log('==========================================');

            setBlockEData(responseBlockEData)
            setVerifyBlockEWorkerEmpRatioE(data.verifyBlockEWorkerEmpRatioE)
            const statusFlage = responseBlockEData[0].statusFlag;
            const IsButtonStatus = await validateButtonASIBlock(decode_token, statusFlage);
            const initialData = {};
            responseBlockEData.forEach(item => {


               initialData[item.catagoryId] = {
                  dslNo: item.dslNo,
                  surveyYear: item.surveyYear,
                  catagoryId: item.catagoryId,
                  manufacturing: (item.manufacturing === "0" || item.manufacturing === '0.00') ? '' : item.manufacturing,
                  nonmanufacturing: (item.nonmanufacturing === "0" || item.nonmanufacturing === '0.00') ? '' : item.nonmanufacturing,
                  total: (item.total === "0" || item.total === '0.00') ? '' : item.total,
                  avgNoPersonsWorked: (item.avgNoPersonsWorked === "0" || item.avgNoPersonsWorked === '0.00') ? 0 : item.avgNoPersonsWorked,
                  noMandaysPaid: (item.noMandaysPaid === "0" || item.noMandaysPaid === '0.00') ? '' : item.noMandaysPaid,
                  wagesOrSalaries: (item.wagesOrSalaries === '' || item.wagesOrSalaries === "0" || item.wagesOrSalaries === '0.00') ? '' : parseInt(item.wagesOrSalaries),
                  categoryOfStaff: item.categoryOfStaff,
                  manufacturingClass: 'textBox_back_color_white',
                  nonmanufacturingClass: 'textBox_back_color_white',
                  totalClass: 'textBox_back_color_white',
                  avgNoPersonsWorkedClass: 'textBox_back_color_white',
                  noMandaysPaidClass: 'textBox_back_color_white',
                  wagesOrSalariesClass: 'textBox_back_color_white',


               };
            });



            setItemData(initialData);
            setButtonStatus(IsButtonStatus)
            
            // Use Item 14 data if found
            if (item14Data && item14CategoryId) {
               localStorage.setItem("blockE19WagesOrSalaries", item14Data.wagesOrSalaries || '');
               // Set context with the loaded value
               const wagesValue = item14Data.wagesOrSalaries;
               const numValue = wagesValue && wagesValue !== '' && wagesValue !== '0' && wagesValue !== '0.00' ? parseFloat(wagesValue) : null;
               setInitialData(numValue);
               // console.log('[BlockE] blockEAllData set context from API (Item 14, catagoryId ' + item14CategoryId + '):', numValue);
               // console.log('[BlockE] Stored in localStorage as blockE19WagesOrSalaries:', item14Data.wagesOrSalaries);
            } else {
               console.warn('[BlockE] Item 14 (Total cost of Production) not found!');
               console.warn('[BlockE] Checked catagoryIds: 114, 113, 56');
               if (Array.isArray(responseBlockEData)) {
                  console.log('[BlockE] Available catagoryIds in response:', responseBlockEData.map(item => item.catagoryId));
               }
            }
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }

   }





   // Function to handle State on change        
   const handleOnBlur = (catagoryId, field, newValue) => {


      let row11 = "";
      let total5 = "";
      let row13column8 = 0;
      let result = 0;
      let total = 0;
      let tabid = document.getElementById('dataTable');

      if (blockInfo.surveyYear === 2023 || blockInfo.surveyYear === 2024) {
         row13column8 = parseInt(document.getElementById("wagesOrSalaries113").value);

         if (isNaN(row13column8) || row13column8 === '' || row13column8 === null) {
            row13column8 = 0;
         }

      } else {

         row13column8 = parseInt(document.getElementById("wagesOrSalaries56").value);

         if (isNaN(row13column8) || row13column8 === '' || row13column8 === null) {
            row13column8 = 0;
         }

      }


      if (blockInfo.surveyYear === 2023 || blockInfo.surveyYear === 2024) {

         for (let j = 96; j <= 105; j++) {
            result = 0;
            row11 = tabid.rows[j + 2];
            const totalElem = document.getElementById("total" + j);
            let total5 = 0;
            if (totalElem && totalElem.value !== undefined && totalElem.value !== null && totalElem.value !== '') {
               total5 = parseFloat(totalElem.value);
               if (isNaN(total5) || total5 === '' || total5 === null) {
                  total5 = 0;
               }
            }
            if (row13column8 !== 0 && total5 !== 0) {
               result = total5 / row13column8;
            }
            if (j === 99 || j === 101) {
               handleTableRowData(j, 'avgNoPersonsWorked', total);
            } else {
               total = total + Math.round(result);
               handleTableRowData(j, 'avgNoPersonsWorked', Math.round(result));
            }
         }


      } else {


         for (let j = 39; j < 46; j++) {

            result = 0;
            row11 = tabid.rows[j + 2];
            total5 = parseInt(document.getElementById("total" + j).value);
            if (isNaN(total5) || total5 === '' || total5 === null) {
               total5 = 0;
            }
            if (row13column8 !== 0 && total5 !== 0) {
               result = total5 / row13column8;
            }
            if (j === 41 || j === 43) {


               // if(blockInfo.surveyYear===2023 && j === 41 ){
               //    let  avgNoPersonsWorked95 = parseInt(document.getElementById("avgNoPersonsWorked95").value);
               //    total =total+avgNoPersonsWorked95;
               // }


               handleTableRowData(j, 'avgNoPersonsWorked', total);
            } else {
               total = total + Math.round(result);
               handleTableRowData(j, 'avgNoPersonsWorked', Math.round(result));
            }
         }


      }








   }

   const handleTableRowData = (IndexId, field, newValue) => {

      setItemData(prevItemData => {
         const updatedItemData = {
            ...prevItemData,
            [IndexId]: {
               ...prevItemData[IndexId],
               [field]: newValue
            }
         };

         return updatedItemData;
      });
   }


   const handleOnChange = (catagoryId, field, newValue) => {

      if (!isNumeric(newValue)) {
         toast.error(messages.NUMERIC_MSG, messages.COLOR_RED);
         newValue = '';
      }


      setItemData(prevItemData => {
         const updatedItemData = {
            ...prevItemData,
            [catagoryId]: {
               ...prevItemData[catagoryId],
               [field]: newValue
            }
         };

         return updatedItemData;
      });
      
      // Item 14 (Total cost of Production) - catagoryId: 114, 113, or 56
      if ((catagoryId === 114 || catagoryId === 113 || catagoryId === 56) && field === "wagesOrSalaries") {
         localStorage.setItem("blockE19WagesOrSalaries", newValue);
         // Convert to number or null if empty
         const numValue = newValue.trim() === '' ? null : parseFloat(newValue);
         setInitialData(numValue); // Context mein bhi set karo
         console.log('[BlockE] onChange set localStorage (Item 14, catagoryId ' + catagoryId + '):', newValue);
         console.log('[BlockE] onChange set context:', numValue);
      }
   }

   // Function to handle reset Form Data
   const handleReset = () => {
      const initialData = {};
      blockEData.forEach(item => {
         initialData[item.catagoryId] = {
            catagoryId: item.catagoryId,
            dslNo: item.dslNo,
            surveyYear: item.surveyYear,
            categoryOfStaff: item.categoryOfStaff,
            manufacturing: '',
            nonmanufacturing: '',
            total: '',
            avgNoPersonsWorked: '',
            noMandaysPaid: '',
            wagesOrSalaries: '',
            manufacturingClass: 'textBox_back_color_white',
            nonmanufacturingClass: 'textBox_back_color_white',
            totalClass: 'textBox_back_color_white',
            avgNoPersonsWorkedClass: 'textBox_back_color_white',
            noMandaysPaidClass: 'textBox_back_color_white',
            wagesOrSalariesClass: 'textBox_back_color_white',
         };
      });

      setItemData(initialData);
   }

   // Function to handle going to the previous block 
   const handlePrevious = () => {
      const confirmed = window.confirm("Have you saved your changes?");
      if (confirmed) {
         //   handleSaveData("SAVE")
         navigate("/BlockD")
      }

   }

   // status=2: Block E se Block L jaate time beech ke blocks ko 0-data se auto-save
   const autoSaveIntermediateBlocksWithZeroDataStatus2 = async () => {
      const clickButtonStatusFlag = getStatusFlagValue("SAVE", userInfoObject?.userLevel);
      const payload = { dsl_no: blockInfo.dslNo, survey_year: blockInfo.surveyYear };
      const getData = (res) => res?.data?.data ?? res?.data ?? {};

      const safePost = async (url, body) => {
         try {
            await axios.post(url, body, config);
            return true;
         } catch (e) {
            console.error(`[BlockE] auto-save failed: ${url}`, e);
            return false;
         }
      };

      // NOTE: User requirement - direct Save APIs only (no Form/Get APIs)
      // We send 0/blank data; backend should create/update default rows.
      const savePayload = { ...payload, buttonType: "SAVE" };

      // Sequential auto-saves (avoid first-call race/errors)
      // Block F: Form -> Save with zeros
      try {
         const res = await axios.post(`${API_URL}api/asi/blockFForm`, payload, config);
         const data = getData(res);
         const rows = data.blockFData || [];
         const itemCodes = rows.map((r) => ({
            dslNo: r.dslNo ?? blockInfo.dslNo,
            surveyYear: r.surveyYear ?? blockInfo.surveyYear,
            itemCode: r.itemCode,
            expenditure: 0,
            statusFlag: clickButtonStatusFlag
         }));
         await safePost(`${API_URL}api/asi/blockFFormSaveToDB`, { itemCodes, payload: savePayload });
      } catch (e) {
         console.error('[BlockE] BlockF Form->Save failed', e);
      }

      // Block G: ALWAYS Form -> Save with zeros (first time fail avoid)
      try {
         const res = await axios.post(`${API_URL}api/asi/blockGForm`, payload, config);
         const data = getData(res);
         const rows = data.blockGData || [];
         const itemCodes = rows.map((r) => ({
            dslNo: r.dslNo ?? blockInfo.dslNo,
            surveyYear: r.surveyYear ?? blockInfo.surveyYear,
            itemCode: r.itemCode,
            recipts: 0,
            statusFlag: clickButtonStatusFlag
         }));
         await safePost(`${API_URL}api/asi/blockGFormSaveToDB`, { itemCodes, payload: savePayload });
      } catch (e) {
         console.error('[BlockE] BlockG Form->Save failed', e);
      }

      // Block H (static list)
      await safePost(`${API_URL}api/asi/blockHFormSaveToDB`, {
         itemCodes: (Array.isArray(BlockHJsonData) ? BlockHJsonData : []).map((r, idx) => ({
            dslNo: blockInfo.dslNo,
            surveyYear: blockInfo.surveyYear,
            srno: 0,
            itemCode: r.itemCode ?? '',
            itemDesc: r.itemDesc ?? '',
            unitOfQty: r.unitOfQty ?? '',
            qtyConsumed: 0,
            purchaseValue: 0,
            ratePerUnit: 0,
            saveOrderBy: idx + 1,
            statusFlag: clickButtonStatusFlag
         })),
         payload: savePayload
      });

      // Block I (static list)
      await safePost(`${API_URL}api/asi/blockIFormSaveToDB`, {
         itemCodes: (Array.isArray(BlockIData) ? BlockIData : []).map((r) => ({
            dslNo: blockInfo.dslNo,
            surveyYear: blockInfo.surveyYear,
            itemCode: r.itemCode ?? '',
            itemDesc: r.itemDesc ?? '',
            purchaseValue: 0,
            qtyConsumed: 0,
            ratePerUnit: 0,
            unitOfQty: r.unitOfQty ?? '',
            statusFlag: clickButtonStatusFlag
         })),
         payload: savePayload
      });

      // Block J (static list)
      await safePost(`${API_URL}api/asi/blockJFormSaveToDB`, {
         itemCodes: (Array.isArray(BlockJData) ? BlockJData : []).map((r) => ({
            dslNo: blockInfo.dslNo,
            surveyYear: blockInfo.surveyYear,
            itemCode: r.itemCode ?? '',
            itemDesc: r.itemDesc ?? '',
            unitOfQty: r.unitOfQty ?? '',
            qtyManufactured: 0,
            qtySold: 0,
            grossSaleValue: 0,
            perunitNetsaleValue: 0,
            exfactoryValueQty: 0,
            distributiveExpensesExciseDuty: 0,
            distributiveExpensesSalesTaxVat: 0,
            distributiveExpensesOthers: 0,
            distributiveExpensesTotal: 0,
            statusFlag: clickButtonStatusFlag
         })),
         payload: savePayload
      });

      // Block K: ALWAYS Form -> Save (needs ictIndicatorCode list)
      try {
         const res = await axios.post(`${API_URL}api/asi/blockKForm`, payload, config);
         const data = getData(res);
         const rows = data.blockKData || [];
         const itemCodes = rows.map((r) => ({
            dslNo: r.dslNo ?? blockInfo.dslNo,
            surveyYear: r.surveyYear ?? blockInfo.surveyYear,
            code: '',
            ictIndicatorCode: r.ictIndicatorCode,
            ItemsName: r.ItemsName,
            statusFlag: clickButtonStatusFlag
         }));
         await safePost(`${API_URL}api/asi/blockKFormSaveToDB`, { itemCodes, payload: savePayload });
      } catch (e) {
         console.error('[BlockE] BlockK Form->Save failed', e);
      }
   };

   // Function to handle going to the next block      
   const handleNext = async () => {
      // Next unlocked + Save disabled → skip save, sirf navigate (DIVASI/FACTO/DISASI/HQ sab)
      if (isNextBlockAlreadyAccessible && (buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag)) {
         navigate(nextBlockRoute);
         return;
      }
      // DOM se latest value lo aur localStorage me set karo
      // Item 14 (Total cost of Production) - Try catagoryId: 114, 113, 56 in priority order
      let inputElem = null;
      let item14CategoryId = null;
      
      // Try catagoryId 114 first
      inputElem = document.getElementById('wagesOrSalaries114');
      if (inputElem) {
         item14CategoryId = 114;
      } else {
         // Try catagoryId 113
         inputElem = document.getElementById('wagesOrSalaries113');
         if (inputElem) {
            item14CategoryId = 113;
         } else {
            // Try catagoryId 56
            inputElem = document.getElementById('wagesOrSalaries56');
            if (inputElem) {
               item14CategoryId = 56;
            }
         }
      }
      
      if (inputElem && item14CategoryId) {
        localStorage.setItem("blockE19WagesOrSalaries", inputElem.value);
        // Convert to number or null if empty
        const numValue = inputElem.value.trim() === '' ? null : parseFloat(inputElem.value);
        setInitialData(numValue); // Context mein bhi set karo
        console.log('[BlockE] handleNext set localStorage (Item 14, catagoryId ' + item14CategoryId + '):', inputElem.value);
        console.log('[BlockE] handleNext set context:', numValue);
      } else {
        console.warn('Input element for Item 14 (Total cost of Production) not found!');
        console.warn('Checked IDs: wagesOrSalaries114, wagesOrSalaries113, wagesOrSalaries56');
        // Try to get value from itemData state as fallback
        const item14Value = itemData[114]?.wagesOrSalaries || itemData[113]?.wagesOrSalaries || itemData[56]?.wagesOrSalaries;
        if (item14Value !== undefined && item14Value !== null && item14Value !== '') {
          localStorage.setItem("blockE19WagesOrSalaries", item14Value);
          const numValue = parseFloat(item14Value);
          setInitialData(numValue);
          console.log('[BlockE] handleNext fallback - using itemData:', numValue);
        }
      }
      // Save and navigate
      // DIVASI + statusFlag=1: do not save, just navigate
      if (isDivasiStatusFlagOne) {
         if (statusUnitCode === '2') {
            navigate("/BlockL");
         } else {
            navigate("/BlockF");
         }
         return;
      }
      // HQADM/HQASI + statusFlag=3: do not save, just navigate
      if (isHqStatusFlagThree) {
         if (statusUnitCode === '2') {
            navigate("/BlockL");
         } else {
            navigate("/BlockF");
         }
         return;
      }
      const confirmed = window.confirm("Have you saved your changes?");
      if (!confirmed) return;
      const saveResult = await handleSaveData("SAVE");
      if (saveResult) {
         if (statusUnitCode === '2') {
            // best-effort autosaves; do not prevent navigation
            await autoSaveIntermediateBlocksWithZeroDataStatus2();
         }
         await blockValidation();
         if (statusUnitCode === '2') {
            navigate("/BlockL");
         } else {
            navigate("/BlockF");
         }
      }
   }


   //All block validation Data
   const blockValidation = async () => {

      let postData = {
         dsl_no: blockInfo.dslNo,
         survey_year: blockInfo.surveyYear
      }

      try {
         showAppLoading(true);
         const response = await axios.post(`${API_URL}api/asi/blockValidation`, postData, config);
         const { data, status } = response.data;
         const accessIds = data.allblockData
         if (accessIds.length > 0) {

            if (accessIds.length > [1, 2, 3, 4, 5, 6].length) {
               accessAsiBlock(accessIds)
            } else {
               accessAsiBlock([1, 2, 3, 4, 5, 6])
            }

         } else {
            accessAsiBlock([1, 2, 3, 4, 5, 6])
         }
         showAppLoading(false);
         return true;

      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {

      }

   }



   // Function to handle update and save form data
   const handleSaveData = async (buttonType) => {


      // status 5 / status 2: allow save with 0 data (like 4,5,7,8 flow)
      if (statusUnitCode !== '5' && statusUnitCode !== '2' && !valForBlockE()) {
         return false;
      }

      //console.log(valForBlockE()); 

      //return false;

      let customItemCodes = [];
      const clickButtonStatusFlag = getStatusFlagValue(buttonType, userInfoObject.userLevel)


      for (let catagoryId in itemData) {


         //let avgNoPersonsWorked=handleValue(itemData[catagoryId].avgNoPersonsWorked)

         //   if(['39','40','95','41','42','43','44','45'].includes(catagoryId) && blockInfo.surveyYear===2023){
         //      let  wagesOrSalaries=handleValue(itemData['55'].wagesOrSalaries); //(iii) Total (i+ii)
         //      let  total=handleValue(itemData[catagoryId].total);
         //      avgNoPersonsWorked=Math.round(total/wagesOrSalaries);

         //     }


         const customObject = {

            dslNo: itemData[catagoryId].dslNo,
            surveyYear: itemData[catagoryId].surveyYear,
            catagoryId: itemData[catagoryId].catagoryId,
            manufacturing: handleValue(itemData[catagoryId].manufacturing),
            nonmanufacturing: handleValue(itemData[catagoryId].nonmanufacturing),
            total: handleValue(itemData[catagoryId].total),
            avgNoPersonsWorked: handleValue(itemData[catagoryId].avgNoPersonsWorked),
            noMandaysPaid: handleValue(itemData[catagoryId].noMandaysPaid),
            wagesOrSalaries: handleValue(itemData[catagoryId].wagesOrSalaries),
            statusFlag: clickButtonStatusFlag
         };
         customItemCodes.push(customObject);
      }

      if (blockInfo.surveyYear === 2023) {
         let dataArray = Object.values(customItemCodes);
         let lastItem = dataArray.pop();
         dataArray.splice(3, 0, lastItem);
         customItemCodes = Object.fromEntries(dataArray.map((item, index) => [index, item]));
         customItemCodes = Object.values(customItemCodes);
      }



      const newObject = {
         itemCodes: customItemCodes,
         payload: {
            dsl_no: blockInfo.dslNo,
            survey_year: blockInfo.surveyYear,
            buttonType: buttonType
            
         }
      }



      showAppLoading(true);


      try {
         const response = await axios.post(`${API_URL}api/asi/blockEFormSaveDB`, newObject, config);
         const { status, message } = response.data;
         if (status) {
            blockValidation()
            toast.success(message, messages.COLOR_RED);
            return true;
         }
      } catch (error) {
         console.error(error);
         toast.error('An error occurred while processing your request.', messages.COLOR_RED);
      } finally {
         showAppLoading(false);
      }
      return false;

      // update post data code
   }


   // Helper function to safely set property on object
   const safeSetProperty = (obj, index, property, value) => {
      if (obj && obj[index]) {
         obj[index][property] = value;
      }
   }

   //Start calculation code
   const valForBlockE = () => {
      // let yearArray = [2017,2018,2019,2020,2021];
      let allObjectData = itemData
      let statusAlertE = ''
      let flagE = 0;
      let msgFlag = '';
      let allValidactionAlertBlockE = '';

      var yearArray = [2023,2024];

      if (yearArray.includes(blockInfo.surveyYear)) {

         let value31 = parseFloat(handleValue(allObjectData[96]?.manufacturing));
         let value32 = parseFloat(handleValue(allObjectData[97]?.manufacturing));
         let value33 = parseFloat(handleValue(allObjectData[98]?.manufacturing));
         let value34 = parseFloat(handleValue(allObjectData[99]?.manufacturing));
         let val3112 = value31 + value32 + value33;
         if (value34 !== val3112) {
            safeSetProperty(allObjectData, 99, 'manufacturingClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 99, 'manufacturingClass', "textBox_back_color_white")
         }

         let value41 = parseFloat(handleValue(allObjectData[96]?.nonmanufacturing));
         let value42 = parseFloat(handleValue(allObjectData[97]?.nonmanufacturing));
         let value43 = parseFloat(handleValue(allObjectData[98]?.nonmanufacturing));
         let value44 = parseFloat(handleValue(allObjectData[99]?.nonmanufacturing));
         let val4112 = value41 + value42 + value43;

         if (value44 !== val4112) {
            safeSetProperty(allObjectData, 99, 'nonmanufacturingClass', "textBox_back_color_red")
            flagE = 1;
         }
         else {
            safeSetProperty(allObjectData, 99, 'nonmanufacturingClass', "textBox_back_color_white")
         }

         for (let j = 0; j <= 8; j++) {

            let manufacturing39 = parseFloat(handleValue(allObjectData[96 + j]?.manufacturing));
            let nonmanufacturing39 = parseFloat(handleValue(allObjectData[96 + j]?.nonmanufacturing));
            let total39 = parseFloat(handleValue(allObjectData[96 + j]?.total));

            let mtotal = manufacturing39 + nonmanufacturing39;

            if (total39 !== mtotal) {
               safeSetProperty(allObjectData, 96 + j, 'totalClass', "textBox_back_color_red")
               flagE = 1;
            } else {
               safeSetProperty(allObjectData, 96 + j, 'totalClass', "textBox_back_color_white")

            }
         }

         //    // start 2023  condition
         //    let manufacturing95 = parseFloat(handleValue(allObjectData[95]?.manufacturing));
         //    let nonmanufacturing95= parseFloat(handleValue(allObjectData[95]?.nonmanufacturing));
         //    let total_namu_non_95 = parseFloat(handleValue(allObjectData[95]?.total));

         //    let mtotal=manufacturing95+nonmanufacturing95;

         //    if(total_namu_non_95!==mtotal){
         //       allObjectData[95].totalClass="textBox_back_color_red"
         //       flagE=1;
         //    }else{
         //       allObjectData[95].totalClass="textBox_back_color_white"

         //    }
         //   // end 2023 condition 



         let manufacturing47 = parseFloat(handleValue(allObjectData[105]?.manufacturing)) //9
         let notManufacturing47 = parseFloat(handleValue(allObjectData[105]?.nonmanufacturing)) //9
         let total47 = parseFloat(handleValue(allObjectData[105]?.total))

         let total = manufacturing47 + notManufacturing47;

         if (total47 !== total) {
            safeSetProperty(allObjectData, 105, 'totalClass', "textBox_back_color_red")
            // valifla="notnull";
            flagE = 1;
         }
         else {
            safeSetProperty(allObjectData, 105, 'totalClass', "textBox_back_color_white")
         }




         // 	Average No. of persons worked Calculation
         let avgNoPersonsWorked39 = parseFloat(handleValue(allObjectData[96]?.avgNoPersonsWorked)) //1
         let avgNoPersonsWorked40 = parseFloat(handleValue(allObjectData[97]?.avgNoPersonsWorked)) //2
         let avgNoPersonsWorked95 = parseFloat(handleValue(allObjectData[98]?.avgNoPersonsWorked)) //3
         let avgNoPersonsWorked41 = parseFloat(handleValue(allObjectData[99]?.avgNoPersonsWorked)) //4
         let val7112 = avgNoPersonsWorked39 + avgNoPersonsWorked40 + avgNoPersonsWorked95;

         if (avgNoPersonsWorked41 !== val7112) {
            //  valifla="notnull";
            safeSetProperty(allObjectData, 99, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 99, 'avgNoPersonsWorkedClass', "textBox_back_color_white")
         }

         // No. of mandays paid Calculation
         let noMandaysPaid39 = parseFloat(handleValue(allObjectData[96]?.noMandaysPaid))
         let noMandaysPaid40 = parseFloat(handleValue(allObjectData[97]?.noMandaysPaid))
         let noMandaysPaid95 = parseFloat(handleValue(allObjectData[98]?.noMandaysPaid))
         let noMandaysPaid41 = parseFloat(handleValue(allObjectData[99]?.noMandaysPaid))
         let val712 = noMandaysPaid39 + noMandaysPaid40 + noMandaysPaid95;

         if (noMandaysPaid41 !== val712) {
            // valifla="notnull";
            safeSetProperty(allObjectData, 99, 'noMandaysPaidClass', "textBox_back_color_red")
            flagE = 1;
         } else {

            if (flagE !== 1) {
               safeSetProperty(allObjectData, 99, 'noMandaysPaidClass', "textBox_back_color_white")
            }

         }

         // Wages/Salaries (in Rs.) Calculation
         let wagesOrSalaries39 = parseFloat(handleValue(allObjectData[96]?.wagesOrSalaries)) //1
         let wagesOrSalaries40 = parseFloat(handleValue(allObjectData[97]?.wagesOrSalaries)) //2
         let wagesOrSalaries95 = parseFloat(handleValue(allObjectData[98]?.wagesOrSalaries)) //3
         let wagesOrSalaries41 = parseFloat(handleValue(allObjectData[99]?.wagesOrSalaries)) //4
         let val12 = wagesOrSalaries39 + wagesOrSalaries40 + wagesOrSalaries95;

         if (wagesOrSalaries41 !== val12) {
            // valifla="notnull";
            safeSetProperty(allObjectData, 99, 'wagesOrSalariesClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 99, 'wagesOrSalariesClass', "textBox_back_color_white")
         }

         // manufacturing 4 and 5 Calculation
         let manufacturing42 = parseFloat(handleValue(allObjectData[100]?.manufacturing))//4
         let manufacturing43 = parseFloat(handleValue(allObjectData[101]?.manufacturing))//5
         let total44 = val3112 + manufacturing42;//val3112(39+40+95)
         if (manufacturing43 !== total44) {
            safeSetProperty(allObjectData, 101, 'manufacturingClass', "textBox_back_color_red")
         } else {
            safeSetProperty(allObjectData, 101, 'manufacturingClass', "textBox_back_color_white")
         }





         // nonmanufacturing 4 and 5 Calculation
         let nonmanufacturing42 = parseFloat(handleValue(allObjectData[100]?.nonmanufacturing))//4
         let nonmanufacturing43 = parseFloat(handleValue(allObjectData[101]?.nonmanufacturing))//5
         let total144 = val4112 + nonmanufacturing42;//val4112(39+40)
         if (nonmanufacturing43 !== total144) {
            safeSetProperty(allObjectData, 101, 'nonmanufacturingClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 101, 'nonmanufacturingClass', "textBox_back_color_white")
         }


         // Average No. of persons worked 4 and 5 Calculation
         let avgNoPersonsWorked42 = parseFloat(handleValue(allObjectData[100]?.avgNoPersonsWorked))//4
         let avgNoPersonsWorked43 = parseFloat(handleValue(allObjectData[101]?.avgNoPersonsWorked))//5
         var total1634 = val7112 + avgNoPersonsWorked42;//val7112(39+40)
         if (avgNoPersonsWorked43 !== total1634) {
            safeSetProperty(allObjectData, 101, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 101, 'avgNoPersonsWorkedClass', "textBox_back_color_white")
         }

         // 	No. of mandays paid 4 and 5 Calculation
         let noMandaysPaid42 = parseFloat(handleValue(allObjectData[100]?.noMandaysPaid))//4
         let noMandaysPaid43 = parseFloat(handleValue(allObjectData[101]?.noMandaysPaid))//5
         var total634 = val712 + noMandaysPaid42;//val712(39+40)
         if (noMandaysPaid43 !== total634) {
            safeSetProperty(allObjectData, 101, 'noMandaysPaidClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            if (flagE !== 1) {
               safeSetProperty(allObjectData, 101, 'noMandaysPaidClass', "textBox_back_color_white")
            }
         }

         // Wages/Salaries (in Rs.) 4 and 5 Calculation
         let wagesOrSalaries42 = parseFloat(handleValue(allObjectData[100]?.wagesOrSalaries))//4
         let wagesOrSalaries43 = parseFloat(handleValue(allObjectData[101]?.wagesOrSalaries))//5
         var total34 = val12 + wagesOrSalaries42; //val12(39+40+95)
         if (wagesOrSalaries43 !== total34) {
            safeSetProperty(allObjectData, 101, 'wagesOrSalariesClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 101, 'wagesOrSalariesClass', "textBox_back_color_white")
         }


         // Supervisory & Managerial staff row 6
         // Manufacturing
         let manufacturing44 = parseFloat(handleValue(allObjectData[102]?.manufacturing)) //6
         let manufacturing45 = parseFloat(handleValue(allObjectData[103]?.manufacturing)) //7
         // (total44 + manufacturing44 + manufacturing45)
         let total44manufacturing44manufacturing45 = parseInt(total44) + parseInt(manufacturing44) + parseInt(manufacturing45);

         if (manufacturing47 !== total44manufacturing44manufacturing45) {
            safeSetProperty(allObjectData, 105, 'manufacturingClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 105, 'manufacturingClass', "textBox_back_color_white")
         }

         // Non Manufacturing
         let nonmanufacturing44 = parseFloat(handleValue(allObjectData[102]?.nonmanufacturing)) //6
         let nonmanufacturing45 = parseFloat(handleValue(allObjectData[103]?.nonmanufacturing)) //7
         let nonmanufacturing47 = parseFloat(handleValue(allObjectData[105]?.nonmanufacturing)) //9

         let total44nonmanufacturing44nonmanufacturing45 = parseInt(total144) + parseInt(nonmanufacturing44) + parseInt(nonmanufacturing45);
         if (nonmanufacturing47 !== total44nonmanufacturing44nonmanufacturing45) {
            safeSetProperty(allObjectData, 105, 'nonmanufacturingClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 105, 'nonmanufacturingClass', "textBox_back_color_white")
         }


         // Average No. of persons worked
         let avgNoPersonsWorked44 = parseFloat(handleValue(allObjectData[102]?.avgNoPersonsWorked)) //6
         let avgNoPersonsWorked45 = parseFloat(handleValue(allObjectData[103]?.avgNoPersonsWorked)) //7
         let avgNoPersonsWorked46 = parseFloat(handleValue(allObjectData[104]?.avgNoPersonsWorked)) //8
         let avgNoPersonsWorked47 = parseFloat(handleValue(allObjectData[105]?.avgNoPersonsWorked)) //9

         let avg43_44_45_46 = parseInt(avgNoPersonsWorked43) + parseInt(avgNoPersonsWorked44) + parseInt(avgNoPersonsWorked45) + parseInt(avgNoPersonsWorked46);



         if (avgNoPersonsWorked47 !== avg43_44_45_46) {
            safeSetProperty(allObjectData, 105, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 105, 'avgNoPersonsWorkedClass', "textBox_back_color_white")
         }

         // No. of mandays paid
         let noMandaysPaid44 = parseFloat(handleValue(allObjectData[102]?.noMandaysPaid)) //6
         let noMandaysPaid45 = parseFloat(handleValue(allObjectData[103]?.noMandaysPaid)) //7
         let noMandaysPaid47 = parseFloat(handleValue(allObjectData[105]?.noMandaysPaid)) //9

         let total634_44_45 = parseInt(total634) + parseInt(noMandaysPaid44) + parseInt(noMandaysPaid45);

         if (noMandaysPaid47 !== total634_44_45) {
            safeSetProperty(allObjectData, 105, 'noMandaysPaidClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            if (flagE !== 1) {
               safeSetProperty(allObjectData, 105, 'noMandaysPaidClass', "textBox_back_color_white")
            }

         }

         let wagesOrSalaries44 = parseFloat(handleValue(allObjectData[102]?.wagesOrSalaries)) //6
         let wagesOrSalaries45 = parseFloat(handleValue(allObjectData[103]?.wagesOrSalaries)) //7
         let wagesOrSalaries47 = parseFloat(handleValue(allObjectData[105]?.wagesOrSalaries)) //9

         let total34_44_45 = parseFloat(total34) + parseFloat(wagesOrSalaries44) + parseFloat(wagesOrSalaries45);
         if (wagesOrSalaries47 !== total34_44_45) {
            safeSetProperty(allObjectData, 105, 'wagesOrSalariesClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 105, 'wagesOrSalariesClass', "textBox_back_color_white")
         }


         // Wages/Salaries (in Rs.) 
         let a = 0
         let wagesOrSalaries53 = parseFloat(handleValue(allObjectData[111]?.wagesOrSalaries)) //15
         let wagesOrSalaries54 = parseFloat(handleValue(allObjectData[112]?.wagesOrSalaries)) //16
         let wagesOrSalaries55 = parseFloat(handleValue(allObjectData[113]?.wagesOrSalaries)) //17

         let total15_16 = parseInt(wagesOrSalaries53) + parseInt(wagesOrSalaries54);
         if (wagesOrSalaries55 !== total15_16) {
            safeSetProperty(allObjectData, 113, 'wagesOrSalariesClass', "textBox_back_color_red")
            flagE = 1;
         } else if (parseInt(wagesOrSalaries55) > 365) {
            alert("Number of working days should be less than 365 days.");
            safeSetProperty(allObjectData, 112, 'wagesOrSalariesClass', "textBox_back_color_red")
            safeSetProperty(allObjectData, 111, 'wagesOrSalariesClass', "textBox_back_color_red")
            safeSetProperty(allObjectData, 113, 'wagesOrSalariesClass', "textBx_back_color_red")

            if (allObjectData[113]) allObjectData[113].wagesOrSalaries = ""
            if (allObjectData[112]) allObjectData[112].wagesOrSalaries = ""
            if (allObjectData[111]) allObjectData[111].wagesOrSalaries = ""
            a = 1
            handleValidationAlert(allObjectData)
            return false;
         } else {
            safeSetProperty(allObjectData, 113, 'wagesOrSalariesClass', "textBox_back_color_white")
         }
         if (a == 0) {
            handleValidationAlert(allObjectData)
         }
         if (flagE == 1) {
            alert("Total does not match. Please check highlighted fields");
            return false;
         }
      } else {


         let value31 = parseFloat(handleValue(allObjectData[39]?.manufacturing));
         let value32 = parseFloat(handleValue(allObjectData[40]?.manufacturing));
         let value33 = parseFloat(handleValue(itemData[41]?.manufacturing));
         let val3112 = value31 + value32;
         if (value33 !== val3112) {
            safeSetProperty(allObjectData, 41, 'manufacturingClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 41, 'manufacturingClass', "textBox_back_color_white")
         }


         let value41 = parseFloat(handleValue(allObjectData[39]?.nonmanufacturing));
         let value42 = parseFloat(handleValue(allObjectData[40]?.nonmanufacturing));
         let value43 = parseFloat(handleValue(itemData[41]?.nonmanufacturing));
         let val4112 = value41 + value42;

         if (value43 !== val4112) {
            safeSetProperty(allObjectData, 41, 'nonmanufacturingClass', "textBox_back_color_red")
            flagE = 1;
         }
         else {
            safeSetProperty(allObjectData, 41, 'nonmanufacturingClass', "textBox_back_color_white")
         }

         let districtCode = verifyBlockEWorkerEmpRatioE.districtCode;
         let minWorkerJs = verifyBlockEWorkerEmpRatioE.minWorker;
         let maxWorkerJs = verifyBlockEWorkerEmpRatioE.maxWorker;
         let minEmpJs = verifyBlockEWorkerEmpRatioE.minEmp;
         let maxEmpJs = verifyBlockEWorkerEmpRatioE.maxEmp;
         let noCheckJsWorker = verifyBlockEWorkerEmpRatioE.noCheckWorker;
         let noCheckJsEmp = verifyBlockEWorkerEmpRatioE.noCheckEmp;
         let fourDigNICCode = verifyBlockEWorkerEmpRatioE.fourDigNICCode;


         // 1 to 5  calculation

         for (let j = 0; j <= 6; j++) {

            let manufacturing39 = parseFloat(handleValue(allObjectData[39 + j]?.manufacturing));
            let nonmanufacturing39 = parseFloat(handleValue(allObjectData[39 + j]?.nonmanufacturing));
            let total39 = parseFloat(handleValue(allObjectData[39 + j]?.total));

            let mtotal = manufacturing39 + nonmanufacturing39;

            if (total39 !== mtotal) {
               safeSetProperty(allObjectData, 39 + j, 'totalClass', "textBox_back_color_red")
               flagE = 1;
            } else {
               safeSetProperty(allObjectData, 39 + j, 'totalClass', "textBox_back_color_white")

            }

            // let noMandaysPaid39 = parseFloat(handleValue(allObjectData[39+j]?.noMandaysPaid));

            // if (total39 > noMandaysPaid39){
            //       allObjectData[39+j].noMandaysPaidClass="textBox_back_color_red"
            //       flagE=1;
            //       statusAlertE=1;
            //       if(msgFlag){
            //          allValidactionAlertBlockE = allValidactionAlertBlockE+"Column 7 Value Shuld be less then Column 5.\n";
            //          msgFlag = false;
            //       }
            // } else {
            //    allObjectData[39+j].noMandaysPaidClass="textBox_back_color_white"
            // }  
         }

         //9 manufacturing calculation
         let manufacturing47 = parseFloat(handleValue(allObjectData[47]?.manufacturing)) //9
         let notManufacturing47 = parseFloat(handleValue(allObjectData[47]?.nonmanufacturing)) //9
         let total47 = parseFloat(handleValue(allObjectData[47]?.total))

         let total = manufacturing47 + notManufacturing47;
         if (total47 !== total) {
            safeSetProperty(allObjectData, 47, 'totalClass', "textBox_back_color_red")
            // valifla="notnull";
            flagE = 1;
         }
         else {
            safeSetProperty(allObjectData, 47, 'totalClass', "textBox_back_color_white")
         }


         // 	Average No. of persons worked Calculation
         let avgNoPersonsWorked39 = parseFloat(handleValue(allObjectData[39]?.avgNoPersonsWorked)) //1
         let avgNoPersonsWorked40 = parseFloat(handleValue(allObjectData[40]?.avgNoPersonsWorked)) //2
         let avgNoPersonsWorked41 = parseFloat(handleValue(allObjectData[41]?.avgNoPersonsWorked)) //3
         let val7112 = avgNoPersonsWorked39 + avgNoPersonsWorked40;

         if (avgNoPersonsWorked41 !== val7112) {
            // valifla="notnull";
            safeSetProperty(allObjectData, 41, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 41, 'avgNoPersonsWorkedClass', "textBox_back_color_white")
         }


         // No. of mandays paid Calculation
         let noMandaysPaid39 = parseFloat(handleValue(allObjectData[39]?.noMandaysPaid))
         let noMandaysPaid40 = parseFloat(handleValue(allObjectData[40]?.noMandaysPaid))
         let noMandaysPaid41 = parseFloat(handleValue(allObjectData[41]?.noMandaysPaid))
         let val712 = noMandaysPaid39 + noMandaysPaid40;

         if (noMandaysPaid41 !== val712) {
            // valifla="notnull";
            safeSetProperty(allObjectData, 41, 'noMandaysPaidClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 41, 'noMandaysPaidClass', "textBox_back_color_white")
         }

         // Wages/Salaries (in Rs.) Calculation
         let wagesOrSalaries39 = parseFloat(handleValue(allObjectData[39]?.wagesOrSalaries)) //1
         let wagesOrSalaries40 = parseFloat(handleValue(allObjectData[40]?.wagesOrSalaries)) //2
         let wagesOrSalaries41 = parseFloat(handleValue(allObjectData[41]?.wagesOrSalaries)) //3
         let val12 = wagesOrSalaries39 + wagesOrSalaries40;

         if (wagesOrSalaries41 !== val12) {
            // valifla="notnull";
            safeSetProperty(allObjectData, 41, 'wagesOrSalariesClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 41, 'wagesOrSalariesClass', "textBox_back_color_white")
         }


         // manufacturing 4 and 5 Calculation
         let manufacturing42 = parseFloat(handleValue(allObjectData[42]?.manufacturing))//4
         let manufacturing43 = parseFloat(handleValue(allObjectData[43]?.manufacturing))//5
         let total44 = val3112 + manufacturing42;//val3112(39+40)
         if (manufacturing43 !== total44) {
            safeSetProperty(allObjectData, 43, 'manufacturingClass', "textBox_back_color_red")
         } else {
            safeSetProperty(allObjectData, 43, 'manufacturingClass', "textBox_back_color_white")
         }


         // nonmanufacturing 4 and 5 Calculation
         let nonmanufacturing42 = parseFloat(handleValue(allObjectData[42]?.nonmanufacturing))//4
         let nonmanufacturing43 = parseFloat(handleValue(allObjectData[43]?.nonmanufacturing))//5
         let total144 = val4112 + nonmanufacturing42;//val4112(39+40)
         if (nonmanufacturing43 !== total144) {
            safeSetProperty(allObjectData, 43, 'nonmanufacturingClass', "textBox_back_color_red")
         } else {
            safeSetProperty(allObjectData, 43, 'nonmanufacturingClass', "textBox_back_color_white")
         }


         // Average No. of persons worked 4 and 5 Calculation
         let avgNoPersonsWorked42 = parseFloat(handleValue(allObjectData[42]?.avgNoPersonsWorked))//4
         let avgNoPersonsWorked43 = parseFloat(handleValue(allObjectData[43]?.avgNoPersonsWorked))//5
         var total1634 = val7112 + avgNoPersonsWorked42;//val7112(39+40)
         if (avgNoPersonsWorked43 !== total1634) {
            safeSetProperty(allObjectData, 43, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
         } else {
            safeSetProperty(allObjectData, 43, 'avgNoPersonsWorkedClass', "textBox_back_color_white")
         }


         // 	No. of mandays paid 4 and 5 Calculation
         let noMandaysPaid42 = parseFloat(handleValue(allObjectData[42]?.noMandaysPaid))//4
         let noMandaysPaid43 = parseFloat(handleValue(allObjectData[43]?.noMandaysPaid))//5
         var total634 = val712 + noMandaysPaid42;//val712(39+40)
         if (noMandaysPaid43 !== total634) {
            safeSetProperty(allObjectData, 43, 'noMandaysPaidClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            if (flagE !== 1) {
               safeSetProperty(allObjectData, 43, 'noMandaysPaidClass', "textBox_back_color_white")
            }
         }

         // Wages/Salaries (in Rs.) 4 and 5 Calculation
         let wagesOrSalaries42 = parseFloat(handleValue(allObjectData[42]?.wagesOrSalaries))//4
         let wagesOrSalaries43 = parseFloat(handleValue(allObjectData[43]?.wagesOrSalaries))//5


         var total34 = val12 + wagesOrSalaries42; //val12(39+40)
         if (wagesOrSalaries43 !== total34) {
            safeSetProperty(allObjectData, 43, 'wagesOrSalariesClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 43, 'wagesOrSalariesClass', "textBox_back_color_white")
         }

         // Supervisory & Managerial staff row 6
         // Manufacturing
         let manufacturing44 = parseFloat(handleValue(allObjectData[44]?.manufacturing)) //6
         let manufacturing45 = parseFloat(handleValue(allObjectData[45]?.manufacturing)) //7
         // (total44 + manufacturing44 + manufacturing45)
         let total44manufacturing44manufacturing45 = parseInt(total44) + parseInt(manufacturing44) + parseInt(manufacturing45);

         if (manufacturing47 !== total44manufacturing44manufacturing45) {
            safeSetProperty(allObjectData, 47, 'manufacturingClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 47, 'manufacturingClass', "textBox_back_color_white")
         }


         // Non Manufacturing
         let nonmanufacturing44 = parseFloat(handleValue(allObjectData[44]?.nonmanufacturing)) //6
         let nonmanufacturing45 = parseFloat(handleValue(allObjectData[45]?.nonmanufacturing)) //7
         let nonmanufacturing47 = parseFloat(handleValue(allObjectData[47]?.nonmanufacturing)) //9

         let total44nonmanufacturing44nonmanufacturing45 = parseInt(total144) + parseInt(nonmanufacturing44) + parseInt(nonmanufacturing45);
         if (nonmanufacturing47 !== total44nonmanufacturing44nonmanufacturing45) {
            safeSetProperty(allObjectData, 47, 'nonmanufacturingClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 47, 'nonmanufacturingClass', "textBox_back_color_white")
         }


         // Average No. of persons worked
         let avgNoPersonsWorked44 = parseFloat(handleValue(allObjectData[44]?.avgNoPersonsWorked)) //6
         let avgNoPersonsWorked45 = parseFloat(handleValue(allObjectData[45]?.avgNoPersonsWorked)) //7
         let avgNoPersonsWorked46 = parseFloat(handleValue(allObjectData[46]?.avgNoPersonsWorked)) //8
         let avgNoPersonsWorked47 = parseFloat(handleValue(allObjectData[47]?.avgNoPersonsWorked)) //9

         let avg43_44_45_46 = parseInt(avgNoPersonsWorked43) + parseInt(avgNoPersonsWorked44) + parseInt(avgNoPersonsWorked45) + parseInt(avgNoPersonsWorked46);


         if (avgNoPersonsWorked47 !== avg43_44_45_46) {
            safeSetProperty(allObjectData, 47, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 47, 'avgNoPersonsWorkedClass', "textBox_back_color_white")
         }

         // No. of mandays paid
         let noMandaysPaid44 = parseFloat(handleValue(allObjectData[44]?.noMandaysPaid)) //6
         let noMandaysPaid45 = parseFloat(handleValue(allObjectData[45]?.noMandaysPaid)) //7
         let noMandaysPaid47 = parseFloat(handleValue(allObjectData[47]?.noMandaysPaid)) //9

         let total634_44_45 = parseInt(total634) + parseInt(noMandaysPaid44) + parseInt(noMandaysPaid45);

         if (noMandaysPaid47 !== total634_44_45) {
            safeSetProperty(allObjectData, 47, 'noMandaysPaidClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 47, 'noMandaysPaidClass', "textBox_back_color_white")
         }


         // Wages / Salaries (in Rs.)
         let wagesOrSalaries44 = parseFloat(handleValue(allObjectData[44]?.wagesOrSalaries)) //6
         let wagesOrSalaries45 = parseFloat(handleValue(allObjectData[45]?.wagesOrSalaries)) //7
         let wagesOrSalaries47 = parseFloat(handleValue(allObjectData[47]?.wagesOrSalaries)) //9
         let wagesOrSalaries49 = parseFloat(handleValue(allObjectData[49]?.wagesOrSalaries)) //11
         let wagesOrSalaries50 = parseFloat(handleValue(allObjectData[50]?.wagesOrSalaries)) //12
         let wagesOrSalaries51 = parseFloat(handleValue(allObjectData[51]?.wagesOrSalaries)) //13

         let total_11_12_13 = parseFloat(wagesOrSalaries49) + parseFloat(wagesOrSalaries50) + parseFloat(wagesOrSalaries51);

         let issueOncells = false;
         if (parseFloat(total_11_12_13) <= 50 * parseFloat(wagesOrSalaries47) / 100) {
            safeSetProperty(allObjectData, 49, 'wagesOrSalariesClass', "textBox_back_color_white")
            safeSetProperty(allObjectData, 50, 'wagesOrSalariesClass', "textBox_back_color_white")
            safeSetProperty(allObjectData, 51, 'wagesOrSalariesClass', "textBox_back_color_white")
         } else {
            allValidactionAlertBlockE = allValidactionAlertBlockE + "Items (10+11+12) <= 50% of col.8 of item 9. \n";
            safeSetProperty(allObjectData, 49, 'wagesOrSalariesClass', "textBox_back_color_red")
            safeSetProperty(allObjectData, 50, 'wagesOrSalariesClass', "textBox_back_color_red")
            safeSetProperty(allObjectData, 51, 'wagesOrSalariesClass', "textBox_back_color_red")
            issueOncells = true;
            statusAlertE = 1;
         }

         if (parseFloat(wagesOrSalaries49) <= 20 * parseInt(wagesOrSalaries47) / 100) {
            if (!issueOncells) {
               safeSetProperty(allObjectData, 49, 'wagesOrSalariesClass', "textBox_back_color_white")
               safeSetProperty(allObjectData, 50, 'wagesOrSalariesClass', "textBox_back_color_white")
               safeSetProperty(allObjectData, 51, 'wagesOrSalariesClass', "textBox_back_color_white")
            }
         } else {
            allValidactionAlertBlockE = allValidactionAlertBlockE + "Item 10  <=  20% of  item 9. Col. 8. \n";
            safeSetProperty(allObjectData, 49, 'wagesOrSalariesClass', "textBox_back_color_red")
            safeSetProperty(allObjectData, 50, 'wagesOrSalariesClass', "textBox_back_color_red")
            safeSetProperty(allObjectData, 51, 'wagesOrSalariesClass', "textBox_back_color_red")
            statusAlertE = 1;
         }

         let total34_44_45 = parseInt(total34) + parseInt(wagesOrSalaries44) + parseInt(wagesOrSalaries45);

         if (wagesOrSalaries47 !== total34_44_45) {
            safeSetProperty(allObjectData, 51, 'wagesOrSalariesClass', "textBox_back_color_red")
            flagE = 1;
         } else {
            safeSetProperty(allObjectData, 51, 'wagesOrSalariesClass', "textBox_back_color_white")
         }

         // Wages/Salaries (in Rs.) 
         let wagesOrSalaries53 = parseFloat(handleValue(allObjectData[53]?.wagesOrSalaries)) //15
         let wagesOrSalaries54 = parseFloat(handleValue(allObjectData[54]?.wagesOrSalaries)) //16
         let wagesOrSalaries55 = parseFloat(handleValue(allObjectData[55]?.wagesOrSalaries)) //17

         let total15_16 = parseInt(wagesOrSalaries53) + parseInt(wagesOrSalaries54);
         if (wagesOrSalaries55 !== total15_16) {
            safeSetProperty(allObjectData, 55, 'wagesOrSalariesClass', "textBox_back_color_red")
            flagE = 1;
         } else if (parseInt(wagesOrSalaries55) > 365) {
            alert("Number of working days should be less than 365 days.");
            safeSetProperty(allObjectData, 54, 'wagesOrSalariesClass', "textBox_back_color_red")
            safeSetProperty(allObjectData, 53, 'wagesOrSalariesClass', "textBox_back_color_red")
            safeSetProperty(allObjectData, 55, 'wagesOrSalariesClass', "textBx_back_color_red")

            if (allObjectData[55]) allObjectData[55].wagesOrSalaries = ""
            if (allObjectData[54]) allObjectData[54].wagesOrSalaries = ""
            if (allObjectData[53]) allObjectData[53].wagesOrSalaries = ""
            return false;
         } else {
            safeSetProperty(allObjectData, 55, 'wagesOrSalariesClass', "textBox_back_color_white")
         }

         let total5 = parseFloat(handleValue(allObjectData[43]?.total)) //5
         let wagesOrSalaries5 = parseFloat(handleValue(allObjectData[43]?.wagesOrSalaries)) //5
         let total9 = parseFloat(handleValue(allObjectData[47]?.total)) //9
         let wagesOrSalaries9 = parseFloat(handleValue(allObjectData[47]?.wagesOrSalaries)) //9

         let total5RatioWorker = 0;
         let total9RatioEmplyee = 0;

         // allObjectData[43].totalClass="textBox_back_color_white"  
         // allObjectData[43].wagesOrSalariesClass="textBox_back_color_white"  
         // allObjectData[47].totalClass="textBox_back_color_white"  
         // allObjectData[47].wagesOrSalariesClass="textBox_back_color_white"  


         if (noCheckJsWorker === 1) {

            total5RatioWorker = Math.round(wagesOrSalaries5 / total5);

            if (total5RatioWorker < minWorkerJs) {
               allValidactionAlertBlockE = allValidactionAlertBlockE + "Total Workers ratio is low \n";
               safeSetProperty(allObjectData, 43, 'totalClass', "textBox_back_color_red")
               safeSetProperty(allObjectData, 43, 'wagesOrSalariesClass', "textBox_back_color_red")
               issueOncells = true;
               statusAlertE = 1;
            }
            if (total5RatioWorker > maxWorkerJs) {
               allValidactionAlertBlockE = allValidactionAlertBlockE + "Total Workers ratio is high \n";
               safeSetProperty(allObjectData, 43, 'totalClass', "textBox_back_color_red")
               safeSetProperty(allObjectData, 43, 'wagesOrSalariesClass', "textBox_back_color_red")
               issueOncells = true;
               statusAlertE = 1;
            }
         }
         if (noCheckJsEmp === 1) {
            total9RatioEmplyee = Math.round(wagesOrSalaries9 / total9);
            if (total9RatioEmplyee < minEmpJs) {
               allValidactionAlertBlockE = allValidactionAlertBlockE + "Total Employees ratio is low \n";
               safeSetProperty(allObjectData, 47, 'totalClass', "textBox_back_color_red")
               safeSetProperty(allObjectData, 47, 'wagesOrSalariesClass', "textBox_back_color_red")
               issueOncells = true;
               statusAlertE = 1;
            } if (total9RatioEmplyee > maxEmpJs) {

               allValidactionAlertBlockE = allValidactionAlertBlockE + "Total Employees ratio is high \n";
               safeSetProperty(allObjectData, 47, 'totalClass', "textBox_back_color_red")
               safeSetProperty(allObjectData, 47, 'wagesOrSalariesClass', "textBox_back_color_red")
               issueOncells = true;
               statusAlertE = 1;
            }
         }


         let numberOfWorkingDays = parseFloat(handleValue(allObjectData[55]?.wagesOrSalaries))

         if (numberOfWorkingDays > 0) {


            /***For Male Workers***/
            let maleWorkerEmpTotal = parseFloat(handleValue(allObjectData[39]?.total))
            let maleWorkerEmpWorked = parseFloat(handleValue(allObjectData[39]?.avgNoPersonsWorked));

            if (maleWorkerEmpTotal > 0) {

               const checkMaleWorker = Math.round(maleWorkerEmpTotal / numberOfWorkingDays);

               if (checkMaleWorker === maleWorkerEmpWorked) {

                  safeSetProperty(allObjectData, 39, 'totalClass', "textBox_back_color_white")
                  safeSetProperty(allObjectData, 39, 'avgNoPersonsWorkedClass', "textBox_back_color_white")

               } else {

                  allValidactionAlertBlockE = allValidactionAlertBlockE + "Male Workers Employed directly = Total Male Workers Employed directly / Total Number of working days.\n";
                  safeSetProperty(allObjectData, 39, 'totalClass', "textBox_back_color_red")
                  safeSetProperty(allObjectData, 39, 'avgNoPersonsWorkedClass', "textBox_back_color_red")

                  statusAlertE = 1;
               }

            }

            /***For Female Workers***/
            let femaleWorkerEmpTotal = parseFloat(handleValue(allObjectData[40]?.total))
            let femaleWorkerEmpWorked = parseFloat(handleValue(allObjectData[40]?.avgNoPersonsWorked))

            if (femaleWorkerEmpTotal > 0) {

               const checkFemaleWorker = parseFloat(femaleWorkerEmpTotal / numberOfWorkingDays);

               if (checkFemaleWorker === femaleWorkerEmpWorked) {

                  safeSetProperty(allObjectData, 40, 'totalClass', "textBox_back_color_white")
                  safeSetProperty(allObjectData, 40, 'avgNoPersonsWorkedClass', "textBox_back_color_white")

               } else {
                  allValidactionAlertBlockE = allValidactionAlertBlockE + "Female Workers Employed directly = Total Female Workers Employed directly / Total Number of working days.\n";
                  safeSetProperty(allObjectData, 40, 'totalClass', "textBox_back_color_red")
                  safeSetProperty(allObjectData, 40, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
                  statusAlertE = 1;
               }
            }

            /***For Contractors Emp***/
            let contractorsWorkerEmpTotal = parseFloat(handleValue(allObjectData[41]?.total))
            let contractorsWorkerEmpWorked = parseFloat(handleValue(allObjectData[41]?.avgNoPersonsWorked))
            if (contractorsWorkerEmpTotal > 0) {

               var checkcontractorWorker = Math.round(contractorsWorkerEmpTotal / numberOfWorkingDays);

               if (checkcontractorWorker === contractorsWorkerEmpWorked) {

                  safeSetProperty(allObjectData, 41, 'totalClass', "textBox_back_color_white")
                  safeSetProperty(allObjectData, 41, 'avgNoPersonsWorkedClass', "textBox_back_color_white")

               } else {
                  allValidactionAlertBlockE = allValidactionAlertBlockE + "Workers employed through contractors = Total Workers employed through contractors / Total Number of working days.\n";
                  safeSetProperty(allObjectData, 41, 'totalClass', "textBox_back_color_red")
                  safeSetProperty(allObjectData, 41, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
                  statusAlertE = 1;
               }
            }
            /***For Supervisory & Managerial staff***/
            let supervisoryAndmanagerialEmpTotal = parseFloat(handleValue(allObjectData[44]?.total))
            let supervisoryAndmanagerialEmpWorked = parseFloat(handleValue(allObjectData[44]?.avgNoPersonsWorked))



            if (supervisoryAndmanagerialEmpTotal > 0) {

               const checksupervisoryAndmanagerial = Math.round(supervisoryAndmanagerialEmpTotal / numberOfWorkingDays);

               if (checksupervisoryAndmanagerial === supervisoryAndmanagerialEmpWorked) {

                  safeSetProperty(allObjectData, 44, 'totalClass', "textBox_back_color_white")
                  safeSetProperty(allObjectData, 44, 'avgNoPersonsWorkedClass', "textBox_back_color_white")

               } else {

                  allValidactionAlertBlockE = allValidactionAlertBlockE + "Supervisory & Managerial staff = Total employed through Supervisory & Managerial staff / Total Number of working days.\n";
                  safeSetProperty(allObjectData, 44, 'totalClass', "textBox_back_color_red")
                  safeSetProperty(allObjectData, 44, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
                  statusAlertE = 1;
               }
            }
            /***For Other Emp***/
            let otherEmpTotal = parseFloat(handleValue(allObjectData[45]?.total))
            let otherEmpWorked = parseFloat(handleValue(allObjectData[45]?.avgNoPersonsWorked))
            if (otherEmpTotal > 0) {

               const checkotherEmp = Math.round(otherEmpTotal / numberOfWorkingDays);
               if (checkotherEmp === otherEmpWorked) {

                  safeSetProperty(allObjectData, 45, 'totalClass', "textBox_back_color_white")
                  safeSetProperty(allObjectData, 45, 'avgNoPersonsWorkedClass', "textBox_back_color_white")

               } else {
                  allValidactionAlertBlockE = allValidactionAlertBlockE + "Other employees = Other Total employees  / Total Number of working days.\n";
                  safeSetProperty(allObjectData, 45, 'totalClass', "textBox_back_color_red")
                  safeSetProperty(allObjectData, 45, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
                  statusAlertE = 1;
               }
            }

            /***** Point Number 2 **/
            let vagNumberPersonWorkedCol6 = parseFloat(handleValue(allObjectData[43]?.avgNoPersonsWorked))
            let wagesOrSalariesCol8 = parseFloat(handleValue(allObjectData[43]?.wagesOrSalaries))
            if (vagNumberPersonWorkedCol6 > 0) {

               var checkMaleWorkerRatio = parseFloat(wagesOrSalariesCol8 / vagNumberPersonWorkedCol6);

               if (6000 < checkMaleWorkerRatio && checkMaleWorkerRatio < 600000) {

                  safeSetProperty(allObjectData, 43, 'avgNoPersonsWorkedClass', "textBox_back_color_white")
                  safeSetProperty(allObjectData, 43, 'wagesOrSalariesClass', "textBox_back_color_white")

               } else {

                  allValidactionAlertBlockE = allValidactionAlertBlockE + "Total Workers, col. 8 / Total Workers, col. 6 should be in range of 6000 to 600000 .\n";
                  safeSetProperty(allObjectData, 43, 'avgNoPersonsWorkedClass', "textBox_back_color_red")
                  safeSetProperty(allObjectData, 43, 'wagesOrSalariesClass', "textBox_back_color_red")

                  statusAlertE = 1;
               }
            }
         }

         handleValidationAlert(allObjectData)
         if (statusAlertE === 1) {
            allValidactionAlertBlockE = allValidactionAlertBlockE + " \nFor change any Values Click OK."
            var clicked = window.confirm(allValidactionAlertBlockE);
            allValidactionAlertBlockE = "";
            statusAlertE = 0;
            if (clicked) {
               return false;
            }
         }

         if (flagE == 1) {
            alert("Total does not match. Please check highlighted fields");
            return false;
         }


      }


      return true;

   }

   //End new calculation code


   // Function to handle set (Update State) form validation and calculation 
   const handleValidationAlert = (blockECustomData) => {
      const initialData = {};

      for (let itemId in blockECustomData) {
         const item = blockECustomData[itemId];
         initialData[itemId] = {
            dslNo: item.dslNo,
            surveyYear: item.surveyYear,
            catagoryId: item.catagoryId,
            manufacturing: item.manufacturing,
            nonmanufacturing: item.nonmanufacturing,
            total: item.total,
            avgNoPersonsWorked: item.avgNoPersonsWorked,
            noMandaysPaid: item.noMandaysPaid,
            wagesOrSalaries: item.wagesOrSalaries,
            categoryOfStaff: item.categoryOfStaff,
            manufacturingClass: item.manufacturingClass,
            nonmanufacturingClass: item.nonmanufacturingClass,
            totalClass: item.totalClass,
            avgNoPersonsWorkedClass: item.avgNoPersonsWorkedClass,
            noMandaysPaidClass: item.noMandaysPaidClass,
            wagesOrSalariesClass: item.wagesOrSalariesClass
         };

      };

      setItemData(initialData);
   }

   // Function to handle if value empty or null or undefined the set 0
   const handleValue = (value) => {
      return (value !== "" && value !== null && value !== undefined) ? value : 0;
   };
   const storedLanguage = localStorage.getItem('language');

   return (
      <div className="card-body">
         {/* <ToastContainer/> */}
         <h4 className="page_heading border-bottom-0">
            <div dangerouslySetInnerHTML={{ __html: storedLanguage === 'hi' ? asiTitle.hi.BLOCK_E_TITLE : asiTitle.en.BLOCK_E_TITLE }} />
         </h4>

         <div className="row">
            <div className="col-12">
               <h6 className="fw-semibold">
                  {storedLanguage === 'hi' ? asiTitle.hi.DSL_NO : asiTitle.en.DSL_NO}: <span className="fw-normal me-5">{blockInfo.dslNo}</span>
                  {storedLanguage === 'hi' ? asiTitle.hi.SERVEY_YEAR : asiTitle.en.SERVEY_YEAR}: <span className="fw-normal">{yearRange}</span>
               </h6>
               <div className="table-responsive asi_block_table">
                  <table cellPadding="0" cellSpacing="0" id="dataTable" className="table table-bordered block_c_table block-e-print-table">
                     <colgroup>
                        <col className="block-e-col-sl" />
                        <col className="block-e-col-cat" />
                        <col className="block-e-col-mfg" />
                        <col className="block-e-col-nonmfg" />
                        <col className="block-e-col-total" />
                        <col className="block-e-col-avg" />
                        <col className="block-e-col-mandays" />
                        <col className="block-e-col-salary" />
                     </colgroup>
                     <thead>
                        <tr>
                           <th rowSpan="2" className="block-e-sl-col">
                              {storedLanguage === 'hi' ? asiTitle.hi.SL_NO : asiTitle.en.SL_NO}
                           </th>
                           <th rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.CATEGORY_OF_STAFF : asiTitle.en.CATEGORY_OF_STAFF}</th>
                           <th colSpan="3" style={{textAlign: 'center'}}>{storedLanguage === 'hi' ? asiTitle.hi.NO_OFMANDAYS_PAID : asiTitle.en.NO_OFMANDAYS_PAID}</th>
                           <th rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.AVG_NO_PERSON_WORK : asiTitle.en.AVG_NO_PERSON_WORK}</th>
                           <th rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.NO_OFMANDAYS_PAID_FOR : asiTitle.en.NO_OFMANDAYS_PAID_FOR}</th>
                           <th rowSpan="2">{storedLanguage === 'hi' ? asiTitle.hi.SALARY : asiTitle.en.SALARY}</th>
                        </tr>
                        <tr>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.MANUFACTURING : asiTitle.en.MANUFACTURING}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.NON_MANUFACTURING : asiTitle.en.NON_MANUFACTURING}</th>
                           <th>{storedLanguage === 'hi' ? asiTitle.hi.TOTAL : asiTitle.en.TOTAL}</th>
                        </tr>
                        <tr>
                           <th>1</th>
                           <th>2</th>
                           <th>3</th>
                           <th>4</th>
                           <th>5</th>
                           <th>6</th>
                           <th>7</th>
                           <th>8</th>
                        </tr>
                     </thead>
                     <tbody>
                        {blockEData.length > 0 && blockEData.map((item, i) => {

                           //console.log(item.categoryOfStaff);

                           return (
                              <>
                                 {(item.catagoryId === 38 || item.catagoryId === 95 || item.catagoryId === 48 || item.catagoryId === 106) ? (
                                    <tr key={i}>
                                       <td colSpan={8}>{item.categoryOfStaff}</td>
                                    </tr>
                                 ) : (
                                    <tr key={i}>
                                       <td>
                                          {
                                             ![48, 53, 54, 55, 111, 112, 113].includes(item.catagoryId) &&
                                             ++srNo
                                          }
                                       </td>
                                       <td>
                                          {
                                             [41, 43, 47, 56, 99, 101, 105, 114].includes(item.catagoryId) ?
                                                <b>{item.categoryOfStaff}</b> : item.categoryOfStaff
                                          }</td>
                                       <td className={itemData[item.catagoryId].manufacturingClass}>
                                          {
                                             ![46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 104, 107, 108, 109, 110, 111, 112, 113, 114].includes(item.catagoryId) &&
                                             <input
                                                type="text"
                                                className="form-control"
                                                value={itemData[item.catagoryId].manufacturing}
                                                id={`manufacturing${item.catagoryId}`}
                                                name={`manufacturing${item.catagoryId}`}
                                                maxLength="12"
                                                onChange={e => handleOnChange(item.catagoryId, 'manufacturing', e.target.value)}
                                             />
                                          }
                                       </td>
                                       <td className={itemData[item.catagoryId].nonmanufacturingClass}>
                                          {
                                             ![46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 104, 107, 108, 109, 110, 111, 112, 113, 114].includes(item.catagoryId) &&
                                             <input
                                                type="text"
                                                className="form-control"
                                                value={itemData[item.catagoryId].nonmanufacturing}
                                                id={`nonmanufacturing${item.catagoryId}`}
                                                name={`nonmanufacturing${item.catagoryId}`}
                                                maxLength="12"
                                                onChange={e => handleOnChange(item.catagoryId, 'nonmanufacturing', e.target.value)}
                                             />
                                          }
                                       </td>
                                       <td className={itemData[item.catagoryId].totalClass}>
                                          {

                                             ![46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 104, 107, 108, 109, 110, 111, 112, 113, 114].includes(item.catagoryId) &&
                                             <input
                                                type="text"
                                                className="form-control"
                                                value={itemData[item.catagoryId].total}
                                                id={`total${item.catagoryId}`}
                                                name={`total${item.catagoryId}`}
                                                maxLength="12"
                                                onChange={e => handleOnChange(item.catagoryId, 'total', e.target.value)}
                                             />
                                          }
                                       </td>
                                       <td className={itemData[item.catagoryId].avgNoPersonsWorkedClass}>
                                          {

                                             ![48, 49, 50, 51, 52, 53, 54, 55, 56, 107, 108, 109, 110, 111, 112, 113, 114].includes(item.catagoryId) &&
                                             <input
                                                type="text"
                                                className="form-control"
                                                value={itemData[item.catagoryId].avgNoPersonsWorked}
                                                id={`avgNoPersonsWorked${item.catagoryId}`}
                                                name={`avgNoPersonsWorked${item.catagoryId}`}
                                                maxLength="12"
                                                disabled={[39, 40, 41, 42, 43, 44, 45, 96, 97, 98, 99, 100, 101, 102, 103].includes(item.catagoryId)}
                                                onChange={e => handleOnChange(item.catagoryId, 'avgNoPersonsWorked', e.target.value)}
                                             />
                                          }
                                       </td>
                                       <td className={itemData[item.catagoryId].noMandaysPaidClass}>
                                          {

                                             ![46, 48, 49, 50, 51, 52, 53, 54, 55, 56, 104, 107, 108, 109, 110, 111, 112, 113, 114].includes(item.catagoryId) &&
                                             <input
                                                type="text"
                                                className="form-control"
                                                value={itemData[item.catagoryId].noMandaysPaid}
                                                id={`noMandaysPaid${item.catagoryId}`}
                                                name={`noMandaysPaid${item.catagoryId}`}
                                                maxLength="12"
                                                onChange={e => handleOnChange(item.catagoryId, 'noMandaysPaid', e.target.value)}
                                             />
                                          }
                                       </td>
                                       <td className={itemData[item.catagoryId].wagesOrSalariesClass}>
                                          {

                                             ![46, 48, 52, 104, 110].includes(item.catagoryId) &&
                                             <input
                                                type="text"
                                                className="form-control"
                                                value={itemData[item.catagoryId].wagesOrSalaries}
                                                id={`wagesOrSalaries${item.catagoryId}`}
                                                name={`wagesOrSalaries${item.catagoryId}`}
                                                maxLength="12"
                                                // onChange={e => handleOnChange(item.catagoryId, 'wagesOrSalaries', e.target.value)}
                                                onChange={e => {
                                                   handleOnChange(item.catagoryId, 'wagesOrSalaries', e.target.value);
                                                   // Item 14 (Total cost of Production) - catagoryId: 114, 113, or 56
                                                   if (item.catagoryId === 114 || item.catagoryId === 113 || item.catagoryId === 56) {
                                                      // Convert to number or null if empty
                                                      const numValue = e.target.value.trim() === '' ? null : parseFloat(e.target.value);
                                                      setInitialData(numValue);
                                                      console.log('[BlockE] Context set for Item 14 (catagoryId ' + item.catagoryId + '):', numValue);
                                                   }
                                                 }}
                                                onBlur={e => handleOnBlur(item.catagoryId, 'wagesOrSalaries', e.target.value)}
                                             />
                                          }
                                       </td>
                                    </tr>
                                 )}
                              </>
                           );
                        })}
                     </tbody>
                  </table>
               </div>
            </div>

         </div>
         <div className="row">
            <div className="col-12">
               <hr />
            </div>

            <div className="col-lg-8 text-center text-lg-start mb-3 mb-lg-0">
               <button
                  type="submit"
                  className="btn btn_orange me-1"
                  onClick={() => { window.print() }}
               >Print
                  <i className="fa fa-print ms-1"></i>
               </button>

               <button
                  type="button"
                  className="btn btn_orange me-1"
                  onClick={(e) => { handleSaveData("SAVE") }}
                  disabled={buttonStatus || isDivasiStatusFlagOne || isHqStatusFlagThree || isRestrictedRoleWithEmptyStatusFlag}
               >
                  Save
               </button>

               <button
                  type="reset"
                  className="btn btn_orange me-1"
                  onClick={handleReset}
               >
                  Reset
               </button>

               <button
                  type="button"
                  className="btn btn_orange"
                  onClick={(e) => (navigate("/dashboard"))}
               >
                  Cancel
               </button>

            </div>

            <div className="col-lg-4 text-center text-lg-end">
               <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={handlePrevious}
               >
                  <i className="fa fa-angle-left me-1"></i>
                  Previous
               </button>

               <button
                  type="button"
                  className="btn btn_orange mx-1"
                  onClick={handleNext}
                  disabled={isNextBlockAlreadyAccessible ? false : (isRestrictedRoleWithEmptyStatusFlag ? true : ((isDivasiStatusFlagOne || isHqStatusFlagThree) ? false : buttonStatus))}
               >
                  Next
                  <i className="fa fa-angle-right ms-1"></i>
               </button>
            </div>
         </div>
      </div>
   )
}
